import { connect } from "react-redux";
import Billing from "./Billing";
import actionCreators from "./redux/actionCreators";
import { getInProgress } from "./redux/selectors";
const mapStateToProps = state => ({
    inProgress: getInProgress(state)
});
const mapDispatchToProps = dispatch => ({
    onInitialized: () => {
        dispatch(actionCreators.actionApiGetBalance());
        dispatch(actionCreators.actionApiGetRequestStatistics());
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(Billing);
